import React from "react";
import ServiceSection, { ServiceSectionProps } from "./base";
import { Box } from "@mui/material";

const ServiceSectionProblem = (props: ServiceSectionProps) => {
  return (
    <ServiceSection service={props.service} headline={props.headline || "こんなことに困っていませんか？"} className="problem">
      <ul>
        {props.service.detail.problem_section.items.map((item: string, index: number) => {
          return (
            <li key={index}>{item}</li>
          )
        })}
      </ul>

      {props.service.detail.problem_section.point && (
        <Box sx={{ flexGrow: 1 }} className="point">
          <p className="strong">ポイント</p>
          <p className="content">{props.service.detail.problem_section.point}</p>
        </Box>
      )}
    </ServiceSection>
  )
}

export default ServiceSectionProblem